module.exports = __webpack_public_path__ + "static/media/2.1e3b1b5c.jpg";